<template>
    <ul v-if="state && state.items" class="ais-Menu-list">
        <li
            v-for="item in mergeCategories"
            :key="item.value"
            class="ais-Menu-item"
            :class="{ 'ais-Menu-item--selected': item.isRefined }">
            <a
                :href="state.createURL(item.value)"
                class="ais-Menu-link"
                @click.prevent="state.refine(item.value)">
                <span class="ais-Menu-label">{{ item.label }}</span>
            </a>
        </li>
    </ul>
</template>

<script>
import { createWidgetMixin } from 'vue-instantsearch';
import { connectMenu } from 'instantsearch.js/es/connectors';

export default {
    name: 'Categories',

    mixins: [createWidgetMixin({ connector: connectMenu })],

    data() {
        return {
            filterActive: false,
        };
    },

    computed: {
        isOnInitialState() {
            if (!this.state || !this.state.items) return null;
            const isRefined = this.state.items.filter((item) => item.isRefined);
            return isRefined.length === 0 ? 'ais-Menu-item--selected' : null;
        },

        widgetParams() {
            return {
                attribute: 'roam_products_categories.lvl0', // only lvl0
            };
        },

        mergeCategories() {
            if (!this.$root || !this.$root.categories || !this.state || !this.state.items) return [];

            const refinedItem = this.state.items.find((item) => item.isRefined);
            const refinedLabel = refinedItem ? refinedItem.label : null;

            return this.$root.categories.map((cat) => {
                let isRefined = false;

                if (cat.label === 'All') {
                    isRefined = !refinedLabel; // nothing selected = 'All'
                } else if (refinedLabel && cat.label === refinedLabel) {
                    isRefined = true;
                }

                return {
                    ...cat,
                    isRefined,
                };
            });
        },

        currentlyRefined() {
            return this.mergeCategories.find((cat) => cat.isRefined);
        },
    },
};
</script>
